module.exports = __webpack_public_path__ + "static/media/Artisanat_PictoCdlT.45b85cb4.png";